import { createGlobalStyle } from 'styled-components';

const GOOGLE_FONTS = 'https://fonts.googleapis.com/css?family=Montserrat:300,700|Open+Sans:400,400i,600,700';

const GlobalStyles = createGlobalStyle`
  @import url(${GOOGLE_FONTS});

  html,
  body,
  #root {
    height: 100%;
  }

  html {
    font-size: 62.5%;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  }

  body {
    font-size: 14px;
    margin: 0;
    background-color: #f7f8fa;
  }

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
`;

export default GlobalStyles;
